"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSessionStore = void 0;
var axios_1 = __importDefault(require("axios"));
var lodash_1 = __importDefault(require("lodash"));
exports.UserSessionStore = {
    sendMessage: function (message, location) {
        var iframe = document.getElementById('servicecommunicator');
        if (iframe !== null && iframe !== undefined) {
            try {
                iframe.contentWindow.postMessage(message, location);
            }
            catch (e) {
                iframe.contentWindow.postMessage(message, location);
            }
        }
    },
    logout: function (userManager, identityServerUrl) {
        var keys = Object.keys(localStorage);
        var key = lodash_1.default.find(keys, function (x) { return x.startsWith('oidc.user'); });
        var user = JSON.parse(localStorage.getItem(key));
        if (identityServerUrl) {
            exports.UserSessionStore.sendMessage('DeleteClientConfirmed', identityServerUrl);
        }
        userManager.signoutRedirect({ id_token_hint: user.id_token });
    },
    addSignoutEventHandler: function (props) {
        props.userManager.events.addUserSignedOut(function () { return exports.UserSessionStore.logoutAndDeleteStorage(props); });
    },
    endImpersonation: function (identityServerUrl) {
        return axios_1.default
            .delete(identityServerUrl + 'api/impersonate')
            .then(function (res) {
            if (res.status === 200) {
                return res.data;
            }
        })
            .then(function () {
            exports.UserSessionStore.sendMessage('NotifyEndingImpersonation', identityServerUrl);
        });
    },
    addMessageEventListener: function (props) {
        window.addEventListener('message', function (event) { return exports.UserSessionStore.processMessage(event, props); }, false);
    },
    processMessage: function (event, props) {
        if (typeof event.data === 'string') {
            if (event.data === 'ImpersonationStarted') {
                exports.UserSessionStore.clientLogoutAndReload(props, props.landingPageRoute);
            }
            else if (event.data.startsWith('ImpersonationEnded|')) {
                exports.UserSessionStore.clientLogoutAndReload(props, event.data.split('|')[1]);
            }
            else if (event.data.startsWith('ChangeClient|')) {
                var returnUrl = event.data.split('|')[1] || '/';
                exports.UserSessionStore.clientLogoutAndReload(props, returnUrl);
            }
            else if (event.data.startsWith('CheckImpersonation|')) {
                var message_1 = event.data.split('|')[1];
                var keys = Object.keys(localStorage);
                lodash_1.default.each(keys, function (x) {
                    if (x.startsWith('oidc.user')) {
                        var storageValue = localStorage.getItem(x);
                        if (storageValue !== null) {
                            var user = JSON.parse(storageValue);
                            var isImpersonating_1 = user.profile.impersonator_name !== undefined;
                            if ((!isImpersonating_1 && message_1 === 'Start') || (isImpersonating_1 && message_1 !== 'Start')) {
                                axios_1.default
                                    .get(props.identityServerUrl + 'api/impersonate')
                                    .then(function (res) {
                                    if (res.status === 200) {
                                        return res.data;
                                    }
                                })
                                    .then(function (isUserActuallyImpersonating) {
                                    exports.UserSessionStore.checkIfUserIsImpersonting(props, isUserActuallyImpersonating, isImpersonating_1, message_1);
                                });
                            }
                            return false;
                        }
                    }
                    return; // equivalent to continue #wierdlodash
                });
            }
            else if (event.data.startsWith('CheckClient|')) {
                var message_2 = event.data.split('|')[1];
                var keys = Object.keys(localStorage);
                lodash_1.default.each(keys, function (x) {
                    if (x.startsWith('oidc.user')) {
                        var storageValue = localStorage.getItem(x);
                        if (storageValue !== null) {
                            var user = JSON.parse(storageValue);
                            if (message_2 !== '' && message_2 !== user.profile.external_clientid) {
                                exports.UserSessionStore.sendMessage('DeleteClientConfirmed', props.identityServerUrl);
                            }
                            return false;
                        }
                    }
                    return;
                });
            }
        }
    },
    checkIfUserIsImpersonting: function (props, isUserActuallyImpersonating, isImpersonating, message) {
        if (isUserActuallyImpersonating !== isImpersonating) {
            exports.UserSessionStore.clientLogoutAndReload(props);
        }
        else {
            if (!isImpersonating && message === 'Start') {
                exports.UserSessionStore.sendMessage('NotifyEndingImpersonation', props.identityServerUrl);
            }
            else if (isImpersonating && message !== 'Start') {
                exports.UserSessionStore.sendMessage('NotifyStartingImpersonation|', props.identityServerUrl);
            }
        }
    },
    logoutAndDeleteStorage: function (props) {
        exports.UserSessionStore.sendMessage('DeleteImpersonationKey', props.identityServerUrl);
        exports.UserSessionStore.sendMessage('DeleteClientConfirmed', props.identityServerUrl);
        axios_1.default
            .delete(props.clientLogoutUrl)
            .then(function (res) {
            if (res.status === 200) {
                return res.data;
            }
        })
            .then(function () { return exports.UserSessionStore.deleteLocalStorage(); })
            .catch(function () { return exports.UserSessionStore.deleteLocalStorage(); });
    },
    clientLogoutAndReload: function (props, navigateToUrl) {
        axios_1.default
            .delete(props.clientLogoutUrl)
            .then(function (res) {
            if (res.status === 200) {
                return res.data;
            }
        })
            .then(function () { return exports.UserSessionStore.removeUser(props, navigateToUrl); })
            .catch(function () { return exports.UserSessionStore.removeUser(props, navigateToUrl); });
    },
    deleteLocalStorage: function () {
        var keys = Object.keys(localStorage);
        lodash_1.default.each(keys, function (x) {
            if (x.startsWith('oidc.user') || x.endsWith('User_LastActiveTime')) {
                localStorage.removeItem(x);
            }
        });
        window.location.reload();
    },
    removeUser: function (props, navigateToUrl) {
        props.userManager.removeUser().then(function () {
            if (navigateToUrl) {
                window.location.href = navigateToUrl;
            }
            else {
                window.location.reload();
            }
        });
    },
};
